import { injectIntl } from 'react-intl';
import compose from 'lodash.flowright';

import { withTracking } from '@xingternal/xing-tracking';
import { trackings } from '@xingternal/platform-layout-trackings';

import { HeaderLoggedOut as HeaderLoggedOutComponent } from './HeaderLoggedOut';

const HeaderLoggedOut = compose(
  injectIntl,
  withTracking(trackings)
)(HeaderLoggedOutComponent);
export { HeaderLoggedOut };
